import React from 'react';
import '../../../App.css';

function Home () {
    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };

    return(
        <>
            <div className='mt-5  container bg-white flex flex-col gap-12'>
                <section>
                    <div className='flex flex-row relative justify-between'>
                        <div className=''>
                            <p className='font-medium text-[21px] cg text-left p-0'>Hey Danny,</p>
                            <p className='text-[#214B32] font-normal text-base'>5 Southern view estate</p>
                        </div>
                        
                        <div className='flex w-12 h-12 rounded-full'>
                            <img src='/images/newHomePic.png' className='rounded-full' alt='profile-pic'/>
                        </div>
                    </div>
                </section>

                <p className='text-[#214B32] text-base font-normal'>What do you want to do today </p>

                <div className='flex flex-wrap text-white gap-4'>
                    <div className='h-[89px] w-[168px] md:w-[188px] rounded-lg grocery-bg flex justify-center items-center'>
                        <p className='text-white'>Grocery Delivery</p>
                    </div>
                    <div className='h-[89px] w-[168px] md:w-[188px] rounded-lg delivery-bg flex justify-center items-center'>
                        <p className='text-white'>Food Delivery</p>
                    </div>
                    <div className='h-[89px] w-[168px] md:w-[188px] rounded-lg maintenance-bg flex justify-center items-center'>
                        <p className='text-white'>Maintenance</p>
                    </div>
                    <div className='h-[89px] w-[168px] md:w-[188px] rounded-lg laundry-bg flex justify-center items-center'>
                        <p className='text-white'>Laundry</p>
                    </div>
                </div>
                
            </div>
        </>
    );
    
}

export default Home;